module.exports = __webpack_public_path__ + "08_face.c73b3669.png";


//////////////////
// WEBPACK FOOTER
// ./src/imgs/custom/aoyama/dad/layer1/08_face.png
// module id = WYSN
// module chunks = 0